export const getRetryStartTime = (endTime: string): string => {
  if (!endTime || endTime.length < 10) return endTime;
  return `${endTime.slice(0, 10)} 00:00:00`;
};
